import { render } from "./LicenseRow.vue?vue&type=template&id=343dbba1&scoped=true"
import script from "./LicenseRow.vue?vue&type=script&lang=js"
export * from "./LicenseRow.vue?vue&type=script&lang=js"

import "./LicenseRow.vue?vue&type=style&index=0&id=343dbba1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343dbba1"]])

export default __exports__